import axiosBase from 'axios'

const axiosEventz = axiosBase.create({
  baseURL: process.env.REACT_APP_EVENTZ_API_URL || '',
})

axiosEventz.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('accessTokenEventz')
    const tenantId = localStorage.getItem('tenantId')

    if (token) {
      config.headers.Authorization = `Bearer ${token}`
    }
    if (tenantId) {
      config.headers['X-Tenant'] = tenantId
    }

    const partnerId = localStorage.getItem('partnerEventz') || localStorage.getItem('partner')
    if (partnerId) {
      config.headers['X-Partner-ID'] = partnerId
    }

    return config
  },
  (error) => Promise.reject(error)
)

axiosEventz.interceptors.response.use(
  (response) => response,
  (error) => Promise.reject((error.response && error.response.data) || 'Something went wrong')
)

export default axiosEventz
